export enum ErrorRecordType {
  Email,
  Recognition
}